import { wccModules } from 'enums/wccModules';
import { inject, injectable, unmanaged } from 'inversify';
import { Observable, PureComputed, Subscribable } from 'knockout';
import { EffectsContainer } from 'mixins/withEffects';
import { TopicCommentsFilterType } from './filterTypes';

export interface TopicCommentsFilterVMConfig<T = any> {
    title: string
    icon: string
    type: TopicCommentsFilterType
    value: Observable<T>
}

@injectable()
export default abstract class TopicCommentFilterVM<T = any> {
    protected outerValue: Observable<T>

    labels = labels

    title: string
    icon: string

    value: Observable<T>

    hasChanges = ko.observable(false);
    isActive: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) public config: TopicCommentsFilterVMConfig<T>,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer,        
        @unmanaged() private defaultValue: T
    ) {
        this.outerValue = config.value;

        this.title = config.title;
        this.icon = config.icon;

        this.value = ko.observable(_.clone(this.outerValue()));

        this.isActive = this.value.is(value => !this.compare(value, defaultValue));

        effects.register([
            this.outerValue.subscribe(value => {
                if (!this.compare(this.value(), value))
                    this.value(_.clone(value));

                this.hasChanges(false);
            }),

            this.value.subscribe(value => {
                this.hasChanges(!this.compare(value, this.outerValue()));
            })            
        ]);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic-comments-filters__filter': true,
                'topic-comments-filters__filter--active': this.isActive
            }
        });
    }

    applyChanges = () => {
        if (this.hasChanges())
            this.outerValue(_.clone(this.value()));
    }

    reset = () => {
        this.value(_.clone(this.defaultValue));
    }

    protected compare(left: T, right: T) {
        return left == right;
    }
}